export default "__VITE_ASSET__a2c3d0fe__"